(function() {
    var hdr = document.getElementById("hdr");
    function sc() {
        hdr.classList.toggle("scrolled", window.scrollY > 24);
    }
    window.addEventListener("scroll", sc, {
        passive: true
    });
    sc();
    var io = new IntersectionObserver(function(es) {
        es.forEach(function(e) {
            if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
            }
        });
    }, {
        threshold: .12
    });
    document.querySelectorAll(".rv").forEach(function(el) {
        io.observe(el);
    });
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    document.querySelectorAll("[data-count]").forEach(function(el) {
        var target = parseInt(el.getAttribute("data-count"), 10);
        var suffix = el.getAttribute("data-suffix") || "";
        if (reduce) {
            el.textContent = target.toLocaleString("en-GB") + suffix;
            return;
        }
        el.textContent = "0" + suffix;
        var cio = new IntersectionObserver(function(en) {
            if (!en[0].isIntersecting) return;
            cio.disconnect();
            var t0 = null;
            function tick(t) {
                if (!t0) t0 = t;
                var k = Math.min(1, (t - t0) / 1300);
                var eased = 1 - Math.pow(1 - k, 3);
                el.textContent = Math.round(target * eased).toLocaleString("en-GB") + suffix;
                if (k < 1) requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
        }, {
            threshold: .4
        });
        cio.observe(el);
    });
})();

//# sourceMappingURL=legendz.c22373fa.js.map
